/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_Allow_HintInputs */

const cs_listing_portals_allow_hint = /** @type {(inputs: Listing_Portals_Allow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez povolení se portál neukáže v detailu nemovitosti ani v poli povinností.`)
};

const en_listing_portals_allow_hint = /** @type {(inputs: Listing_Portals_Allow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unless allowed, this portal stays hidden on property detail and field chips.`)
};

/**
* | output |
* | --- |
* | "Unless allowed, this portal stays hidden on property detail and field chips." |
*
* @param {Listing_Portals_Allow_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_allow_hint = /** @type {((inputs?: Listing_Portals_Allow_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_Allow_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_allow_hint(inputs)
	return cs_listing_portals_allow_hint(inputs)
});